import { WorkRequirementDetailScreen } from "@/interactors/WorkRequirementDetailScreen";

export default function WorkRequirementDetail() {
  return <WorkRequirementDetailScreen />;
}
